import type { ReactNode } from "react";

/**
 * "Is there anything worth drawing a wrapper around?" — the gate every `{slot &&
 * <wrapper>{slot}</wrapper>}` in this folder needs and `&&` does not give.
 */
export function isRenderable(node: ReactNode): boolean {
  /* `== null` takes `undefined` with it, and `typeof` takes BOTH booleans —
     `true` draws nothing either, and a `{a || b}` slot can produce it. */
  if (node == null || typeof node === "boolean") {
    return false;
  }
  if (Array.isArray(node)) {
    return node.some(isRenderable);
  }
  if (typeof node === "string" && node.trim().length === 0) {
    return false;
  }
  return node !== "" && node !== 0;
}
